<script lang="javascript">
    import CommentVisibility from "../../Models/Enums/CommentVisibility";
    import Tooltip from "../Tooltip.svelte";
    import CommentView from "./CommentView.svelte";

    export let thread = null;
</script>

<style lang="scss">

    
    .thread-summary-view {
        cursor:pointer;
        background-color: #eee;
    }
    .thread-summary-view p, 
    .thread-summary-view p.thread-title, 
    .thread-summary-view a {
        font-weight: bold;
        font-size:14px !important;
        line-height:22px;
        padding:0px;
        margin:0px;
        margin-top:0px !important;
        margin-bottom:5px !important;
    }
    .thread-summary-view p.thread-meta {
        font-weight: normal;
    }
    .thread-summary-view p.thread-meta span.material-icons {
        margin-left:5px;
        margin-right:5px;
        vertical-align: bottom;
    } 

</style>

<!-- <ThreadView vessel={vessel} thread={thread} /> -->
<div class="msgbox mb-10 msg oa thread-summary-view" on:click> <!-- use on:click that is passed to it-->
    <div class="oa">
        <p class='thread-title fl'>{thread.readableTitle}</p>

        {#if thread.visibility === CommentVisibility.PUBLIC}
            <p class='thread-title fr'>
                <Tooltip text={thread.visibilityDescription}>
                    {thread.visibilityName}
                </Tooltip>
            </p>
        {/if}
        {#if thread.locked}
            <p class='thread-title fr' style="cursor:default;">
                <Tooltip text={"Locked"}>
                    <span class="material-icons" style="line-height:16px;font-size:16px;">lock</span>
                </Tooltip>
            </p>
        {/if}
        
    </div>

    <CommentView comment={thread.firstComment} showEditTools={false}/>
    <p class='thread-meta'>
        <Tooltip inline text={thread.commentCount + " Comment/s"}><span class="material-icons">comment</span>{thread.commentCount}</Tooltip>&nbsp;
        <Tooltip inline text={thread.userCount + " User/s"}><span class="material-icons">{#if thread.userCount == 1}person{:else}people{/if}</span>{thread.userCount}</Tooltip>&nbsp;
        {#if thread.attachmentCount > 0}<Tooltip inline text={thread.attachmentCount + " Attachment/s"}><span class="material-icons">description</span>{thread.attachmentCount}</Tooltip>{/if}
    </p>
    <!-- {#if thread.comment_count > 1}
        <CommentView comment={thread.last_comment} showModerationTools={false}/>
    {/if} -->
</div>